import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { BookingService } from '../service/booking.service';
import { ToastMessageService } from '../toast-message.service';

@Component({
  selector: 'app-edit-internal-booking-comment',
  templateUrl: './edit-internal-booking-comment.component.html',
  styleUrls: ['./edit-internal-booking-comment.component.css']
})
export class EditInternalBookingCommentComponent implements OnInit {

  body!: string;

  constructor(
    public bookingService: BookingService,
    private httpService: HttpService,
    private toastService: ToastMessageService
  ) { }

  ngOnInit(): void {
  }

  updateComment(){
    this.bookingService.selectedBookingComment!.body = this.bookingService.internalCommentForm.value.body;
    this.httpService.updateInternalBookingComment(this.bookingService.selectedBookingComment!).subscribe(() => {
      this.bookingService.selectedBookingComment!.isModified = true;
      this.bookingService.selectedBookingComment = null;
      this.bookingService.internalCommentForm.reset();
      this.bookingService.activeInternalBookingCommentEdit = false;
      this.toastService.addSuccess("Success", "Your post is updated!");
    }, error => {
      this.toastService.addError("Error", error.error.message);
    });
  }

}
